/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_DescInputs */

const en_media_tab_desc = /** @type {(inputs: Media_Tab_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a media version for playback, or import a new file.`)
};

const fr_media_tab_desc = /** @type {(inputs: Media_Tab_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez une version multimédia pour la lecture, ou importez un nouveau fichier.`)
};

const de_media_tab_desc = /** @type {(inputs: Media_Tab_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Medienversion zur Wiedergabe aus oder importieren Sie eine neue Datei.`)
};

const it_media_tab_desc = /** @type {(inputs: Media_Tab_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una versione del file multimediale da riprodurre oppure importa un nuovo file.`)
};

const ru_media_tab_desc = /** @type {(inputs: Media_Tab_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите версию медиафайла для воспроизведения или импортируйте новый файл.`)
};

const es_media_tab_desc = /** @type {(inputs: Media_Tab_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una versión multimedia para su reproducción o importe un archivo nuevo.`)
};

const zh_cn2_media_tab_desc = /** @type {(inputs: Media_Tab_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要播放的媒体版本，或导入新文件。`)
};

const ja_media_tab_desc = /** @type {(inputs: Media_Tab_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生するメディアバージョンを選択するか、新しいファイルをインポートしてください。`)
};

const hi_media_tab_desc = /** @type {(inputs: Media_Tab_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेबैक के लिए मीडिया संस्करण चुनें, या एक नई फ़ाइल आयात करें।`)
};

const pt_pt2_media_tab_desc = /** @type {(inputs: Media_Tab_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma versão de mídia para reprodução ou importe um novo arquivo.`)
};

/**
* | output |
* | --- |
* | "Select a media version for playback, or import a new file." |
*
* @param {Media_Tab_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_desc = /** @type {((inputs?: Media_Tab_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_desc(inputs)
	if (locale === "de") return de_media_tab_desc(inputs)
	if (locale === "it") return it_media_tab_desc(inputs)
	if (locale === "ru") return ru_media_tab_desc(inputs)
	if (locale === "es") return es_media_tab_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_desc(inputs)
	if (locale === "ja") return ja_media_tab_desc(inputs)
	if (locale === "hi") return hi_media_tab_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_desc(inputs)
	return en_media_tab_desc(inputs)
});